export const EXCEPT_ROUTES = ['login', 'forget-password', 'reset-password'];